<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="ch02"><span><a href="#/Contents#ch-02"><span class="line">WHERE ARE THEY NOW?</span></a></span></h2>
<p class="center"><span><a id="page_4"></a><a href="#/Contents#ch-02"><i>The Neanderthals</i></a></span></p>
<p class="noindent"><span><i>Dear Uncle John,</i></span></p>
<p class="noindent"><span><i>My dad keeps saying that all the guys I date are like Neanderthals. Who are these Neanderthals? Are they cute, and where can I find some?</i></span></p>
<p class="noindent"><span><i>Mad at Dad</i></span></p>
<p class="noindent"><span>Dear Mad at Dad,</span></p>
<p class="noindentbad"><span>Neanderthals, or <i>Homo neanderthalensis,</i> appeared approximately 250,000 to 30,000 years ago and lived in an area bordered by Britain on the west and Iraq in the east—a big piece of territory. Neanderthals had large (like really large) noses, massive eyebrow ridges, big teeth, and no chins. These days, they’d be candidates for extreme makeovers.</span></p>
<p class="indent"><span>Are your boyfriends mentally challenged? Neanderthals developed a reputation for having plenty of brawn but tiny brains. Actually, their brains were as large as Dad’s—or any modern human’s. Recently, science has given the Neanderthals credit for inventing the world’s first “crazy glue,” an adhesive made from birch pitch that the clever Neanderthals developed to attach flint knives to wooden handles.</span></p>
<p class="indent"><span>These days, it’s tough to date a Neanderthal because they haven’t been heard from since they disappeared about 30,000 years ago. Some scientists theorized that modern humans have a bit of Neanderthal in them. But so far, DNA evidence indicates that Neanderthals aren’t our ancestors and that these folks are extinct—completely gone—though obviously not forgotten by your dad.</span></p>
<p class="center-box"><span><b>The prolific author Isaac Asimov was a claustrophile—he <i>liked</i> small, enclosed spaces.</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter02.vue?fc31d6ec